import React, { useRef, useState } from "react";
import QrScanner from "qr-scanner";
import { toast } from "react-hot-toast";
import { FiUploadCloud } from "react-icons/fi";

const QrUploadScanner = ({ onScanStart, onScanSuccess, onScanError }) => {
  const [isScanning, setIsScanning] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (onScanStart) onScanStart();

    setIsScanning(true);
    try {
      const result = await QrScanner.scanImage(file, {
        returnDetailedScanResult: true,
      });
      onScanSuccess(result.data);
      toast.success("QR Code scanned successfully!");
    } catch (err) {
      console.error(err);
      toast.error(err === "No QR code found" ? "No QR code found in the image." : "Error scanning QR code.");
      if (onScanError) onScanError(err);
    } finally {
      setIsScanning(false);
      // Reset input so the same file can be uploaded again if needed
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors duration-200 w-full max-w-md mx-auto"
      onClick={triggerFileInput}
    >
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
      />
      <FiUploadCloud className="text-4xl text-gray-500 mb-2" />
      <p className="text-gray-700 font-medium">
        {isScanning ? "Scanning..." : "Click to upload QR Image"}
      </p>
      <p className="text-sm text-gray-500 mt-1">
        Supports JPG, PNG formats
      </p>
    </div>
  );
};

export default QrUploadScanner;
